import { Component } from '@angular/core';

/** Coquille hôte : barre de titre (vente) + ajout/modification produit bibliothèque. */
@Component({
  selector: 'app-add-product-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class AddProductShellComponent {}
